import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: '--- FIREBASE API KEY ---',
  authDomain: '--- FIREBASE AUTH DOMAIN ---',
  projectId: '--- FIREBASE PROJECT ID ---',
  storageBucket: '--- FIREBASE STORAGE BUCKET ---',
  messagingSenderId: '--- FIREBASE MESSAGING SENDER ID ---',
  appId: '--- FIREBASE APP ID ---',
  measurementId: '--- FIREBASE MEASUREMENT ID ---',
};

export const firebaseApp = initializeApp(firebaseConfig);
